import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearFilterResults } from './filterResultsActions';
import { setFilterValue, setFilterValues, clearFilterValues, clearSearchValue, clearSearchAndFilterValues } from './filterValuesActions';
import { selectFilterValues } from './selectFilterValues';
import { selectHasSearchSet } from './selectHasSearchSet';
export const useFilterValues = () => {
  const filterValues = useSelector(selectFilterValues);
  const hasSearchTerm = useSelector(selectHasSearchSet);
  const dispatch = useDispatch();
  const _setFilterValue = useCallback((filterKey, filterValue) => {
    dispatch(setFilterValue({
      filterKey,
      filterValue
    }));
  }, [dispatch]);
  const _setFilterValues = useCallback(newValues => {
    dispatch(setFilterValues(newValues));
  }, [dispatch]);
  const _clearFilterValues = useCallback(() => {
    dispatch(clearFilterValues());
    if (!hasSearchTerm) {
      dispatch(clearFilterResults());
    }
  }, [dispatch, hasSearchTerm]);
  const clearSearchText = useCallback(() => {
    dispatch(clearSearchValue());
  }, [dispatch]);
  const clearAllFilterValuesAndSearch = useCallback(() => {
    dispatch(clearSearchAndFilterValues());
  }, [dispatch]);
  return {
    filterValues,
    setFilterValue: _setFilterValue,
    setFilterValues: _setFilterValues,
    clearFilterValues: _clearFilterValues,
    clearSearchText,
    clearAllFilterValuesAndSearch
  };
};